module.exports = __webpack_public_path__ + "b4d357b40c1869b214abba0608ca4fa1.jpg";